import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./documentReuse.sass";
import { BASE } from "../basedata/constants";
import { apiUser } from "../basedata/apiCall";

import rgIcon from './../images/document_type.svg'
import cnhIcon from './../images/document_type_cnh.svg'
import { Box } from "@mui/material";
import MobilePagination from "../Components/MobilePagination/MobilePagination";
import { useStep } from "../context/StepContext"
import Illustration from "../Components/Illustration/Illustration"


const DocumentReuse = () => {
  const { t } = useTranslation(); 
  const { setStep } = useStep();

  const chooseDocument = async () => {
    const _current_token = sessionStorage.getItem('token')
    try{
      const _response = await apiUser.post(`/biometry/document/reuse`, {flowId: _current_token})
      if(_response.data?.status === 'success'){
        return window.location.href = '/success'
      }
      return window.location.href = '/document-handler'
    }catch(e){
      console.log(e)
      return window.location.href = '/success'
    }
  }

  useEffect(() => {
    setStep(3);
  }, [])

  return (
    <div className="document-reuse-wrapper">
      <div className="document-reuse-left-side"></div> 
      <div className="document-reuse-right-side">
        <div className="document-reuse-card">
          <h1 className="document-reuse-title">
            {t("document_reuse.title")}
          </h1>
          <Illustration src="./ilustra-doc-frente.png" alt='documento'/>
          <div className="document-reuse-message-container">
            <p className="document-reuse-message-doc">
                {t("document_reuse.quote")}
            </p>

            <button onClick={chooseDocument} className="document-reuse-button">
              {t("document_reuse.call_to_action_positive")}
            </button>

            <button onClick={() => { window.location.href = '/document-handler' }} className="document-reuse-button ghost">
              {t("document_reuse.call_to_action_negative")}
            </button>

            <p className="document-reuse-disclaimer">
              {t("document_reuse.warning_text")}{" "}
              <a
                href="https://storage.googleapis.com/companies-assets/bepay/bepay-zig-privacy-notice.pdf"
                rel="noreferrer noopener"
                target="_blank"
                className="document-reuse-link"
              >
                {t("document_reuse.warning_call_to_action")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentReuse;